export const studentPassFailInfo = [
  { studentId: 79100, pass: 'pass' },
  { studentId: 105688, pass: 'pass' },
  { studentId: 134233, pass: 'pass' },
  { studentId: 136068, pass: 'pass' },
  { studentId: 150746, pass: 'pass' },
  { studentId: 11908, pass: 'fail' },
  { studentId: 58867, pass: 'fail' },
  { studentId: 30342, pass: 'fail' },
  { studentId: 107266, pass: 'fail' },
  { studentId: 111586, pass: 'fail' },

  // kiboko sample 추가
  { studentId: 139930, pass: 'pass' },
  { studentId: 26724, pass: 'fail' },
  { studentId: 16722, pass: 'fail' },
  { studentId: 55830, pass: 'fail' },
  { studentId: 121909, pass: 'fail' },
  { studentId: 49056, pass: 'fail' },
  { studentId: 120952, pass: 'fail' },
  { studentId: 87491, pass: 'fail' },
  { studentId: 68978, pass: 'fail' },
  { studentId: 20530, pass: 'fail' },
];

export const studentScoreInfo = [
  // 건너뛰기 데모용 학생
  {
    studentId: 79100,
    kcInfos: [{ kcId: '11-KC43', accuracy: 0.964285714285714, intime: 1.0 }],
  },
  {
    studentId: 105688,
    kcInfos: [{ kcId: '11-KC22', accuracy: 1.0, intime: 1.0 }],
  },
  {
    studentId: 134233,
    kcInfos: [{ kcId: '11-KC22', accuracy: 1.0, intime: 1.0 }],
  },
  {
    studentId: 136068,
    kcInfos: [{ kcId: '11-KC05', accuracy: 0.88571428571428579, intime: 1.0 }],
  },
  {
    studentId: 150746,
    kcInfos: [{ kcId: '11-KC39', accuracy: 1.0, intime: 1.0 }],
  },
  {
    studentId: 105688,
    kcInfos: [{ kcId: '11-KC03', accuracy: 1.0, intime: 1.0 }],
  },

  // 뒤로가기 데모용 학생
  {
    studentId: 11908,
    kcInfos: [
      { kcId: '11-KC36', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC39', accuracy: 0.79999999999999, intime: 1.0 },
      { kcId: '11-KC42', accuracy: 0.37931034482758, intime: 0.25 },
      { kcId: '11-KC43', accuracy: 0.73469387755102, intime: 1.0 },
    ],
  },
  {
    studentId: 58867,
    kcInfos: [
      // { kcId : "11-KC36" , accuracy : , intime: },
      // { kcId : "11-KC39" , accuracy : , intime: },
      // { kcId : "11-KC37" , accuracy : , intime: },
      // { kcId : "11-KC44" , accuracy : , intime: },
      // { kcId : "11-KC45" , accuracy : , intime: },
      // { kcId : "11-KC47" , accuracy : , intime: },
      {
        kcId: '11-KC55',
        accuracy: 0.735632183908046,
        intime: 0.833333333333333,
      },
      { kcId: '11-KC56', accuracy: 0.228070175438596, intime: 1.0 },
      { kcId: '11-KC57', accuracy: 0, intime: 1.0 },
    ],
  },
  {
    studentId: 30342,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC02', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC28', accuracy: 0.944444444444444, intime: 1.0 },
      { kcId: '11-KC30', accuracy: 0.875, intime: 1.0 },
      {
        kcId: '11-KC32',
        accuracy: 0.925925925925925,
        intime: 0.777777777777777,
      },
      {
        kcId: '11-KC34',
        accuracy: 0.93103448275862,
        intime: 0.428571428571428,
      },
      { kcId: '11-KC35', accuracy: 0.633333333333333, intime: 1.0 },
    ],
  },
  {
    studentId: 107266,
    kcInfos: [
      // { kcId : "11-KC36" , accuracy : , intime: },
      // { kcId : "11-KC39" , accuracy : , intime: },
      // { kcId : "11-KC42" , accuracy : , intime: },
      // { kcId : "11-KC43" , accuracy : , intime: },
      // { kcId : "11-KC49" , accuracy : , intime: },
      // { kcId : "11-KC50" , accuracy : , intime: },
      { kcId: '11-KC51', accuracy: 0.907407407407407, intime: 1.0 },
      {
        kcId: '11-KC52',
        accuracy: 0.666666666666667,
        intime: 0.857142857142857,
      },
    ],
  },
  {
    studentId: 111586,
    kcInfos: [
      { kcId: '11-KC36', accuracy: 0.95, intime: 0.3333333333333333 },
      { kcId: '11-KC39', accuracy: 1.0, intime: 1.0 },
      {
        kcId: '11-KC37',
        accuracy: 0.870967741935483,
        intime: 0.833333333333333,
      },
      { kcId: '11-KC44', accuracy: 1.0, intime: 0.0 },
      { kcId: '11-KC45', accuracy: 0.142857142857143, intime: 0.75 },
    ],
  },
  // kiboko
  {
    studentId: 139930,
    kcInfos: [{ kcId: '11-KC22', accuracy: 0.8363636363636364, intime: 1.0 }],
  },
  {
    studentId: 26724,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC02', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC03', accuracy: 1.0, intime: 0.5 },
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 1.0, intime: 1.0 },
      {
        kcId: '11-KC07',
        accuracy: 0.8064516129032259,
        intime: 0.3333333333333333,
      },
    ],
  },
  {
    studentId: 16722,
    kcInfos: [
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 0.47887323943661975, intime: 0 },
      { kcId: '11-KC07', accuracy: 0.6799999999999999, intime: 0.5 },
      { kcId: '11-KC08', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC09', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC10', accuracy: 1.0, intime: 0.75 },
      { kcId: '11-KC16', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC17', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC18', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC19', accuracy: 0.9166666666666666, intime: 0 },
      { kcId: '11-KC21', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC22', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC23', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC25', accuracy: 0.8999999999999999, intime: 1.0 },
      {
        kcId: '11-KC27',
        accuracy: 0.7653061224489797,
        intime: 0.7777777777777778,
      },
    ],
  },
  {
    studentId: 55830,
    kcInfos: [
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC07', accuracy: 1.0, intime: 0.2 },
      { kcId: '11-KC08', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC09', accuracy: 0.95833333333333326, intime: 0 },
      { kcId: '11-KC10', accuracy: 1.0, intime: 0.66666666666666674 },
      { kcId: '11-KC16', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC17', accuracy: 0.95454545454545447, intime: 0 },
      { kcId: '11-KC18', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC19', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC21', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC22', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC23', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC25', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC27', accuracy: 0.56756756756756754, intime: 0.55 },
    ],
  },
  {
    studentId: 121909,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC02', accuracy: 1.0, intime: 1.0 },
      {
        kcId: '11-KC28',
        accuracy: 0.9333333333333333,
        intime: 0.7000000000000001,
      },
      { kcId: '11-KC29', accuracy: 0.8500000000000001, intime: 1.0 },
      { kcId: '11-KC30', accuracy: 1.0, intime: 0.75 },
      { kcId: '11-KC31', accuracy: 0.9230769230769231, intime: 1.0 },
      { kcId: '11-KC32', accuracy: 1.0, intime: 0.8571428571428571 },
      { kcId: '11-KC33', accuracy: 0.7391304347826086, intime: 0.8 },
    ],
  },
  {
    studentId: 49056,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 1.0, intime: 0.6666666666666666 },
      { kcId: '11-KC02', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC03', accuracy: 1.0, intime: 0.6666666666666666 },
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC07', accuracy: 0.84375, intime: 0.16666666666666669 },
      { kcId: '11-KC08', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC09', accuracy: 0.9583333333333334, intime: 0 },
      { kcId: '11-KC10', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC16', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC17', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC18', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC19', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC21', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC22', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC23', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC25', accuracy: 1.0, intime: 1.0 },
      {
        kcId: '11-KC27',
        accuracy: 0.8656716417910448,
        intime: 0.7142857142857143,
      },
    ],
  },
  {
    studentId: 120952,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 1.0, intime: 0.8333333333333334 },
      { kcId: '11-KC02', accuracy: 0.9285714285714286, intime: 1.0 },
      { kcId: '11-KC03', accuracy: 0.9285714285714286, intime: 1.0 },
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC07', accuracy: 0.9, intime: 0.5 },
      { kcId: '11-KC08', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC09', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC10', accuracy: 1.0, intime: 0.6666666666666667 },
    ],
  },
  {
    studentId: 87491,
    kcInfos: [
      { kcId: '11-KC01', accuracy: 0.923076923076923, intime: 1.0 },
      { kcId: '11-KC02', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC03', accuracy: 0.6923076923076923, intime: 0.6666666666666667 },
      { kcId: '11-KC04', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC05', accuracy: 0.9714285714285714, intime: 1.0 },
      { kcId: '11-KC07', accuracy: 0.5454545454545455, intime: 0.5 },
    ],
  },
  {
    studentId: 68978,
    kcInfos: [
      { kcId: '11-KC16', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC17', accuracy: 1.0, intime: 0.8333333333333334 },
      { kcId: '11-KC18', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC19', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC21', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC22', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC23', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC25', accuracy: 1.0, intime: 1.0 },
      { kcId: '11-KC27', accuracy: 0.4444444444444445, intime: 1.0, },
    ],
  },
  {
    studentId: 20530,
    kcInfos: [
      { kcId: '11-KC28', accuracy: 1.0, intime: 0.8888888888888888 },
      { kcId: '11-KC29', accuracy: 0.9642857142857143, intime: 1.0 },
      { kcId: '11-KC30', accuracy: 1.0, intime: 0.625 },
      { kcId: '11-KC31', accuracy: 1.0, intime: 0.875 },
      { kcId: '11-KC32', accuracy: 0.8333333333333334, intime: 0.8 },
      { kcId: '11-KC33', accuracy: 0.7999999999999998, intime: 0.9090909090909091
    },
    ],
  },
];
